import PropTypes from 'prop-types';
import React from 'react';
import styles from './Checkbox.less';

const Checkbox = (props) => {
  return (
    <div className={styles.container}>
      <input
        tabIndex={props.tabIndex ? props.tabIndex : ''}
        checked={props.checked}
        id={props.id}
        onChange={props.onChange}
        type="checkbox"
        disabled={props.disabled}
      />
      <label htmlFor={props.id}>{props.text}</label>
    </div>
  );
};

Checkbox.propTypes = {
  text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func,
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
};

export default Checkbox;
